import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-global-migrate",
  "use": "icon-soc-global-migrate-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" fill=\"none\" id=\"icon-soc-global-migrate\">\r\n  <!-- ???????????? + ??? -->\r\n  <g fill=\"none\" stroke=\"currentColor\" stroke-width=\"64\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\r\n    <rect x=\"416\" y=\"256\" width=\"384\" height=\"512\" rx=\"48\" />\r\n    <path d=\"M544 384h192M544 512h128M544 640h160\" />\r\n    <path d=\"M128 512h256M288 384l160 128-160 128\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-global-migrate.svg
// module id = PXTc
// module chunks = 477